import Marquee from "../src/Marquee";
import $ from "jquery";
import "../../css/components/_marquee.scss";

$(document).ready(function () {
  $(".marquee").each(function () {
    const marquee = new Marquee(this, {
      speed: 0.5,
      // direction: "right",
      // pauseOnHover: true,
    });
    $(window).resize(() => {
      marquee.refresh();
    });
  });
});
